import * as CubiqTS from "shared/cubiq-model-multi-asset";
import {
  ContextMenuItemState,
  BfxBlotterContextMenuItem,
  BfxBlotterAction,
  ContextMenuState,
} from "../../../../../shared/cubiq-services";
import { BfxLadderBlotterContextMenuEvent } from "../../../../bfx-base-blotter/bfx-base-blotter-contextmenu.service";

/*
 * Client Orders menu structure
 * + MenuItem[]
 * - + ItemState
 */

/* Client Orders - ItemState */
export class BmarkClientOrdersContextMenuItemState extends ContextMenuItemState {
  public acceptanceReference: Map<CubiqTS.AcceptanceType, string[]> = new Map<
    CubiqTS.AcceptanceType,
    string[]
  >();
  constructor() {
    super();
  }
}

/* Client Orders - MenuItem */
export class BmarkClientOrdersContextMenuItem extends BfxBlotterContextMenuItem<any> {
  public state: BmarkClientOrdersContextMenuItemState = new BmarkClientOrdersContextMenuItemState();
  constructor(
    public actionId: BfxBlotterAction,
    title: string = "",
    public iconClass: string = null,
  ) {
    super(
      actionId,
      title,
      () => {
        return;
      },
      () => {
        return;
      },
    );
    this.state.title = title;
    if (typeof iconClass === "string") {
      this.state.iconClass = iconClass;
    } else {
      this.state.iconClass = " ";
    }
    this.state.available = null;
    this.state.enabled = null;
  }
}

/* Client Orders Blotter - MenuEvent */
export class BfxLadderBlotterClientOrdersContextMenuEvent extends BfxLadderBlotterContextMenuEvent<CubiqTS.InterventionEventImpl> {}
